export class PathParameter {
  public static fillParam(path: string, key: string, value: string) {
    var map: any = {};
    map[key] = value;
    return PathParameter.fillParams(path, map);
  }

  /**
   * Same as fillParams but will throw an error if some parameters has not been replaced
   */
  public static fillAllParams(
    path: string,
    pathParameters: { [key: string]: string | number },
  ): string {
    path = PathParameter.fillParams(path, pathParameters);
    const remainingArgs = PathParameter.extractParams(path);
    if (remainingArgs.length > 0) {
      throw new Error(
        `Missing path parameter ${remainingArgs.join(', ')} (path: ${path})`,
      );
    }
    return path;
  }

  public static fillParams(
    path: string,
    mapping: { [key: string]: number | string },
  ) {
    for (var key in mapping) {
      var match = '{' + key + '}';
      if (path.indexOf(match) >= 0) {
        path = path.replace(match, mapping[key].toString());
      } else {
        throw new Error(
          'Parameter ' + key + ' does not exist in path: ' + path,
        );
      }
    }

    return path;
  }

  /**
   *
   * @param path
   * @returns names of path parameters
   */
  public static extractParams(path: string): string[] {
    var found = [],
      rxp = PathParameter.PARAMETER_REGEX,
      curMatch;

    while ((curMatch = rxp.exec(path))) {
      found.push(curMatch[1]);
    }
    return found;
  }

  public static hasParams(path: string): boolean {
    return PathParameter.extractParams(path).length > 0;
  }
}

export namespace PathParameter {
  export const PARAMETER_REGEX = /{([^}]+)}/g;
}
